import useSessionStorage from './useSessionStorage';

export default useSessionStorage;
